import { LANG_COMMON } from '@/constants/languageIdList'
import { languageCollection } from '@/constants/languageList'

const commonName = languageCollection[LANG_COMMON].name

export default commonName
